module.exports = __webpack_public_path__ + "static/IMC_logo_EN-81b3be5c77736520ed5a9b37a622af15.svg";